import { useStore } from 'zustand';
import { identity } from 'ramda';
import {
  QuickSearchState,
  QuickSearchStore,
  quickSearchStore,
} from '@/scopes/search/quick-search/infrastructure/store/store';

export const useQuickSearchSelector = <T, A extends unknown[] = []>(
  selector: (state: QuickSearchState, ...args: A) => T,
  ...args: A
): T => {
  const store = useStore(quickSearchStore, identity<QuickSearchStore>);
  return selector(store, ...args);
};
